import React from "react";
import {SearchByContactStrategy} from "./search-by-contact.strategy";
import {BookingSearchFieldsContainerBox} from "../common/booking-search-fields-container.box";
import {StringFieldEditorComponent} from "../../../../components/forms/string-field/string-field-editor.component";
import {observer} from "mobx-react";
import {EmailFieldEditorComponent} from "../../../../components/forms/contact/email-field-editor.component";
import {PhoneFieldEditorComponent} from "../../../../components/forms/contact/phone-field-editor.component";

export const SearchByContactComponent: React.FC<{ strategy: SearchByContactStrategy }> = observer((props) => {
    const fields = props.strategy.fields;

    return (
        <BookingSearchFieldsContainerBox>
            <StringFieldEditorComponent field={fields.firstName} showClearButton={true}/>
            <StringFieldEditorComponent field={fields.lastName} showClearButton={true}/>
            <PhoneFieldEditorComponent field={fields.phoneNumber} showClearButton={true}/>
            <StringFieldEditorComponent field={fields.recordLocator} showClearButton={true}/>
            <EmailFieldEditorComponent field={fields.emailAddress} showClearButton={true}/>
        </BookingSearchFieldsContainerBox>
    );
});